import React from "react";
import TimeInput from "./TimeInput";
import { Formik } from "formik";



function TimeInputDisplay() {



return (

	<div>
<Formik
			initialValues={{
	          time1: ""
	        }}

 			// all validation rules go in here
	        validate={(values) => {
	          const errors = {};
		      // time picker
          	  // check time has value

	          if (!values.time1) {
	            errors.time1 = "Pick a Time";
	          }
		
	          return errors;
			}}

			>
			
			
		   {({
          values /* all data need to run the valdation*/,
          errors /* all error strings */,
          touched /* all field touch event  */,
          handleChange /* value change event handler */,
          handleBlur /* onBlur event handler */,
          handleSubmit /* for submit button */,
          isSubmitting /* for submit button */,
          isValid /* for submit button */,
          dirty /* for submit button */,
          validateForm
          /* and other goodies */
        }) => (
          <form onSubmit={handleSubmit}>

		
			 <TimeInput
		      id={"timeInput" }
		      value={new Date()}
		      label={"Time"}
		      increase={15}
		      isRequired={true}
		      //onChange={(t) => setTI1(t == null ? "null" : t.toLocaleTimeString())}
		      // same as date picker, rsuite return time string, have to manually setup time and run validation
		      onChange={(time) => {
		        values.time1 = "";
		        if (time) {
		          values.time1 = time.toLocaleTimeString();
		          //1setTI1(time.toLocaleTimeString());
		        }
		        validateForm();
		      }}
		      // same as date picker, can use default value, and manually run validation
		      onBlur={(e) => {
		        if (e.target.innerText) {
		          values.time1 = e.target.innerText;
		          //2setTI1(e.target.innerText);
		        }
		        validateForm();
		      }}
		      // onfocus return true
		      onFocus={(e) => {
		        touched.time1 = e;
		      }}
		      hasError={touched.time1 && errors.time1}
		      errorMessage={errors.time1}
		      />
			errors: {JSON.stringify(errors)}

			  
	          </form>
        )}
      </Formik>
    </div>
  );

}
export default TimeInputDisplay;


